/* unplugin-vue-components disabled */import script from "./ThemePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThemePicker.vue?vue&type=script&setup=true&lang=ts"

import "./ThemePicker.vue?vue&type=style&index=0&id=07ecadc6&lang=css"

const __exports__ = script;

export default __exports__